var team;

team = function() {
  var $, Masonry, module, moduleName, teamLayout, waitForImages;
  Masonry = require('masonry-layout');
  waitForImages = require('jquery.waitforimages');
  $ = require('jquery');
  moduleName = 'team';
  module = $("." + moduleName);
  if (module.length < 1) {
    return false;
  }
  teamLayout = module.find("." + moduleName + "__layout");
  return teamLayout.waitForImages({
    waitForAll: true
  }).done(function() {
    return teamLayout = new Masonry("." + moduleName + "__layout", {
      itemSelector: "." + moduleName + "__item",
      columnWidth: 430
    });
  });
};

module.exports = team;
